export enum Environment {
  LOCAL = 'local',
  PRELIVE = 'prelive',
  LIVE = 'live',
  PRELIVEHOPP = 'prelivehopp',
  LIVEHOPP = 'livehopp',
}

export enum AppBrand {
  BOLT = 'bolt',
  HOPP = 'hopp',
}

export type StringPerEnvironment = { [key in Environment]: string };

const DEEPLINK_SCHEMAS: StringPerEnvironment = {
  [Environment.LOCAL]: 'boltdriverapp://',
  [Environment.PRELIVE]: 'boltdriverapp://',
  [Environment.LIVE]: 'boltdriverapp://',
  [Environment.PRELIVEHOPP]: 'boltdriverappprelive-hopp://',
  [Environment.LIVEHOPP]: 'boltdriverapp-hopp://',
};

const DRIVER_PORTAL_DOMAIN: StringPerEnvironment = {
  [Environment.LOCAL]: 'http://localhost:4200',
  [Environment.PRELIVE]: 'https://partners.prelive.bolt.eu',
  [Environment.LIVE]: 'https://partners.bolt.eu',
  [Environment.PRELIVEHOPP]: 'https://partners.prelive.hopp.app',
  [Environment.LIVEHOPP]: 'https://partners.hopp.app',
};

const SIGNUP_LANDING_DOMAIN: StringPerEnvironment = {
  [Environment.LOCAL]: 'http://localhost:4200',
  [Environment.PRELIVE]: 'https://prelive.bolt.eu',
  [Environment.LIVE]: 'https://bolt.eu',
  [Environment.PRELIVEHOPP]: 'https://prelive.hopp.app',
  [Environment.LIVEHOPP]: 'https://hopp.app',
};

const COOKIE_DOMAIN: StringPerEnvironment = {
  [Environment.LOCAL]: 'localhost',
  [Environment.PRELIVE]: '.prelive.bolt.eu',
  [Environment.LIVE]: '.bolt.eu',
  [Environment.PRELIVEHOPP]: '.prelive.hopp.app',
  [Environment.LIVEHOPP]: '.hopp.app',
};

const APP_STORE_LINK: StringPerEnvironment = {
  [Environment.LOCAL]: 'https://boltdriver.onelink.me/phUm/lvew0z3s',
  [Environment.PRELIVE]: 'https://boltdriver.onelink.me/phUm/lvew0z3s',
  [Environment.LIVE]: 'https://boltdriver.onelink.me/phUm/lvew0z3s',
  [Environment.PRELIVEHOPP]: 'https://boltdriver.onelink.me/phUm/lvew0z3s', // TODO: replace when link is ready
  [Environment.LIVEHOPP]: 'https://boltdriver.onelink.me/phUm/lvew0z3s', // TODO: replace when link is ready
};

export const getCurrentEnvironment = (): Environment => {
  if (process.env.TARGET_ENV) {
    switch (process.env.TARGET_ENV) {
      case 'prelive':
        return Environment.PRELIVE;
      case 'prelivehopp':
        return Environment.PRELIVEHOPP;
      case 'live':
        return Environment.LIVE;
      case 'local':
      default:
        return Environment.LOCAL;
    }
  }

  const hostUrl = window.location.host;
  if (hostUrl.includes('.prelive.hopp.app')) {
    return Environment.PRELIVEHOPP;
  }
  if (hostUrl.includes('.prelive.bolt')) {
    return Environment.PRELIVE;
  }
  if (hostUrl.includes('.hopp.app')) {
    return Environment.LIVEHOPP;
  }
  if (hostUrl.includes('localhost') || hostUrl.includes('docker.internal')) {
    return Environment.LOCAL;
  }
  return Environment.LIVE;
};

export const getAppBrand = (): AppBrand => {
  const environment = getCurrentEnvironment();
  if (
    environment === Environment.PRELIVEHOPP ||
    environment === Environment.LIVEHOPP
  ) {
    return AppBrand.HOPP;
  }
  return AppBrand.BOLT;
};

export const getDeeplinkScheme = (): string => {
  return DEEPLINK_SCHEMAS[getCurrentEnvironment()];
};

export const getDriverPortalDomain = (): string => {
  return DRIVER_PORTAL_DOMAIN[getCurrentEnvironment()];
};

export const getSignupLandingDomain = (): string => {
  return SIGNUP_LANDING_DOMAIN[getCurrentEnvironment()];
};

export function getDomainForCookies(): string {
  return COOKIE_DOMAIN[getCurrentEnvironment()];
}

export function getLinkToAppStore(): string {
  return APP_STORE_LINK[getCurrentEnvironment()];
}

export function getServerHost(): string {
  switch (getCurrentEnvironment()) {
    case Environment.LOCAL:
      return 'http://node.local.internal';
    case Environment.PRELIVE:
    case Environment.PRELIVEHOPP:
      return 'https://prelive.boltsvc.net';
    case Environment.LIVE:
    case Environment.LIVEHOPP:
    default:
      return 'https://live.boltsvc.net';
  }
}

export function getGeoServerHost(): string {
  switch (getCurrentEnvironment()) {
    case Environment.LOCAL:
      return 'http://node.local.internal/geo';
    case Environment.PRELIVE:
    case Environment.PRELIVEHOPP:
      return 'https://geo.prelive.bolt.eu';
    case Environment.LIVE:
    case Environment.LIVEHOPP:
    default:
      return 'https://geo.bolt.eu';
  }
}
